
const ExamList = r => require(['@/pages/exam/gaokao/index'], r) // 考试列表
const LevelType = r => require(['@/pages/exam/gaokao/levelType'], r) // 考试列表
const ChooseExam = r => require(['@/pages/exam/gaokao/chooseExam'], r) // 考试列表
const ChooseExam2 = r => require(['@/pages/exam/gaokao/chooseExam2'], r) // 考试列表
const SetLevel = r => require(['@/pages/exam/gaokao/setLevel'], r) // 考试列表
const SetLevel2 = r => require(['@/pages/exam/gaokao/setLevel2'], r) // 考试列表
const StudentSubmit = r => require(['@/pages/exam/gaokao/student_submit'], r) // 考试列表

const ReportLayout   = r => require(['@/pages/exam/gaokao/report/layout'], r)
const ReportSummaryBasic   = r => require(['@/pages/exam/gaokao/report/summary/basic'], r)
const ReportSummaryRegionBasic   = r => require(['@/pages/exam/gaokao/report/summary/regionBasic'], r)
const ReportSummaryScoreSection   = r => require(['@/pages/exam/gaokao/report/summary/scoreSection'], r)
const ReportSummaryTranscript   = r => require(['@/pages/exam/gaokao/report/summary/transcript'], r)
const ReportSummaryExamBasic   = r => require(['@/pages/exam/gaokao/report/examBasic'], r)

const ReportSubjectBasic   = r => require(['@/pages/exam/gaokao/report/subject/basic'], r)
const ReportSubjectRegionBasic   = r => require(['@/pages/exam/gaokao/report/subject/regionBasic'], r)
const ReportSubjectScoreSection   = r => require(['@/pages/exam/gaokao/report/subject/scoreSection'], r)
const ReportLiKeBasic   = r => require(['@/pages/exam/gaokao/report/like/basic'], r)
const ReportLiKeLevelAnalysis   = r => require(['@/pages/exam/gaokao/report/like/levelAnalysis'], r)
const ReportLiKeScoreSection  = r => require(['@/pages/exam/gaokao/report/like/scoreSection'], r)
const ReportLiKetranscript  = r => require(['@/pages/exam/gaokao/report/like/transcript'], r)
const ReportWenkeBasic   = r => require(['@/pages/exam/gaokao/report/wenke/basic'], r)
const ReportWenkeLevelAnalysis   = r => require(['@/pages/exam/gaokao/report/wenke/levelAnalysis'], r)
const ReportWenkeScoreSection  = r => require(['@/pages/exam/gaokao/report/wenke/scoreSection'], r)
const ReportWenketranscript  = r => require(['@/pages/exam/gaokao/report/wenke/transcript'], r)

export default [
  {
    path: "/region/exam/gaokao",
    name: 'exam-gaokao',
    component: ExamList,
    meta: { auth: "Region-Exam-Gaokao", keepAlive: true }
  },
  {
    path: "/region/exam/gaokao/levelType",
    name: "LevelType",
    component: LevelType,
    meta: { auth: "Region-Exam-Gaokao", keepAlive: true }
  },
  {
    path: "/region/exam/gaokao/chooseExam",
    name: "ChooseExam",
    component: ChooseExam,
    meta: { auth: "Region-Exam-Gaokao", keepAlive: false }
  },
  {
    path: "/region/exam/gaokao/chooseExam2",
    name: "ChooseExam2",
    component: ChooseExam2,
    meta: { auth: "Region-Exam-Gaokao", keepAlive: false }
  },
  {
    path: "/region/exam/gaokao/setLevel",
    name: "SetLevel",
    component: SetLevel,
    meta: { auth: "Region-Exam-Gaokao", keepAlive: false }
  },
  {
    path: "/region/exam/gaokao/setLevel2",
    name: "SetLevel2",
    component: SetLevel2,
    meta: { auth: "Region-Exam-Gaokao", keepAlive: false }
  },
  {
    path: "/region/exam/gaokao/student_submit",
    name: "StudentSubmit",
    component: StudentSubmit,
    meta: { auth: "Region-Exam-Gaokao", keepAlive: true }
  },

  {
    path: "/region/exam/gaokao/report/:id",
    component: ReportLayout,
    children: [
      // 汇总报表
      {
        path: "/region/exam/gaokao/report/:id/summary",
        meta: { auth: "Region-Exam-Gaokao-Report-Sum" },
        component: () =>
          import("@/pages/exam/gaokao/report/summary/layout.vue"),
        redirect: "/region/exam/gaokao/report/:id/summary/basic",
        children: [
          {
            path: "/region/exam/gaokao/report/:id/summary/regionBasic",
            meta: { auth: "Region-Exam-Gaokao-Report-Sum" },
            component: ReportSummaryRegionBasic,
            name: "gaokao-summaryReport-regionBasic"
          },
          {
            path: "/region/exam/gaokao/report/:id/summary/basic",
            meta: { auth: "Region-Exam-Gaokao-Report-Sum" },
            component: ReportSummaryBasic,
            name: "gaokao-summaryReport-basic"
          },
          {
            path: "/region/exam/gaokao/report/:id/summary/scoreSection",
            meta: { auth: "Region-Exam-Gaokao-Report-Sum" },
            component: ReportSummaryScoreSection,
            name: "gaokao-summaryReport-scoreSection"
          },
          {
            path: "/region/exam/gaokao/report/:id/summary/transcript",
            meta: { auth: "Region-Exam-Gaokao-Report-Sum" },
            component: ReportSummaryTranscript,
            name: "gaokao-summaryReport-transcript"
          }
        ]
      },

      // 主科报表
      {
        path: "/region/exam/gaokao/report/:id/subject",
        meta: { auth: "Region-Exam-Gaokao-Report-Subject" },
        component: () =>
          import("@/pages/exam/gaokao/report/subject/layout.vue"),
        name: "Region-Exam-Gaokao-Report-Subject",
        redirect: "/region/exam/gaokao/report/:id/subject/basic",
        children: [
          {
            path: "/region/exam/gaokao/report/:id/subject/regionBasic",
            meta: { auth: "Region-Exam-Gaokao-Report-Main" },
            component: ReportSubjectRegionBasic,
            name: "Gaokao-Main-Gaokao-Report-regionBasic"
          },
          {
            path: "/region/exam/gaokao/report/:id/subject/basic",
            meta: { auth: "Region-Exam-Gaokao-Report-Main" },
            component: ReportSubjectBasic,
            name: "Gaokao-Main-Gaokao-Report-Basic"
          },
          {
            path: "/region/exam/gaokao/report/:id/subject/scoreSection",
            meta: { auth: "Region-Exam-Gaokao-Report-Main" },
            component: ReportSubjectScoreSection,
            name: "Gaokao-Summary-Report-ScoreSection"
          },
          {
            path: "/region/exam/gaokao/report/:id/subject/transcript",
            meta: { auth: "Region-Exam-Gaokao-Report-Main" },
            component: ReportSummaryTranscript,
            name: "Gaokao-Main-Report-Transcript"
          }
        ]
      },

      // 理科报表
      {
        path: "/region/exam/gaokao/report/:id/like",
        meta: { auth: "Region-Exam-Gaokao-Report-Like" },
        component: () => import("@/pages/exam/gaokao/report/like/layout.vue"),
        name: "Region-Exam-Gaokao-Report-Like",
        // redirect: "/region/exam/gaokao/report/:id/like/basic",
        children: [
          {
            path: "/region/exam/gaokao/report/:id/like/basic",
            meta: { auth: "Region-Exam-Gaokao-Report-Like" },
            component: ReportLiKeBasic,
            name: "gaokao-likeReport-basic"
          },
          {
            path: "/region/exam/gaokao/report/:id/like/levelAnalysis",
            meta: { auth: "Region-Exam-Gaokao-Report-Like" },
            component: ReportLiKeLevelAnalysis,
            name: "gaokao-likeReport-levelAnalysis"
          },
          {
            path: "/region/exam/gaokao/report/:id/like/scoreSection",
            meta: { auth: "Region-Exam-Gaokao-Report-Like" },
            component: ReportLiKeScoreSection,
            name: "gaokao-likeReport-scoreSection"
          },
          {
            path: "/region/exam/gaokao/report/:id/like/transcript",
            meta: { auth: "Region-Exam-Gaokao-Report-Like" },
            component: ReportLiKetranscript,
            name: "gaokao-likeReport-transcript"
          },
          {
            path: "/region/exam/gaokao/report/:id/like/examBasic",
            component: ReportSummaryExamBasic,
            name: "gaokao-summaryReport-examBasic"
          }
        ]
      },

      // 文科报表
      {
        path: "/region/exam/gaokao/report/:id/wenke",
        meta: { auth: "Region-Exam-Gaokao-Report-Wenke" },
        component: () => import("@/pages/exam/gaokao/report/wenke/layout.vue"),
        name: "Region-Exam-Gaokao-Report-Wenke",
        // redirect: "/region/exam/gaokao/report/:id/wenke/basic",
        children: [
          {
            path: "/region/exam/gaokao/report/:id/wenke/basic",
            meta: { auth: "Region-Exam-Gaokao-Report-Wenke" },
            component: ReportWenkeBasic,
            name: "gaokao-wenkeReport-basic"
          },
          {
            path: "/region/exam/gaokao/report/:id/wenke/levelAnalysis",
            meta: { auth: "Region-Exam-Gaokao-Report-Wenke" },
            component: ReportWenkeLevelAnalysis,
            name: "gaokao-wenkeReport-levelAnalysis"
          },
          {
            path: "/region/exam/gaokao/report/:id/wenke/scoreSection",
            meta: { auth: "Region-Exam-Gaokao-Report-Wenke" },
            component: ReportWenkeScoreSection,
            name: "gaokao-wenkeReport-scoreSection"
          },
          {
            path: "/region/exam/gaokao/report/:id/wenke/transcript",
            meta: { auth: "Region-Exam-Gaokao-Report-Wenke" },
            component: ReportWenketranscript,
            name: "gaokao-wenkeReport-transcript"
          },
          {
            path: "/region/exam/gaokao/report/:id/wenke/examBasic",
            component: ReportSummaryExamBasic,
            name: "gaokao-summaryReport-examBasic"
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/gaokao.js